import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SceneSettingsModalPage } from './scene-settings-modal.page';
import { ColorPickerModule } from 'ngx-color-picker';
import { InformationPopupComponentModule } from 'src/app/popovers/information-popup/information-popup.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from 'src/app/callback.pipes.module';
import { ResourceDirectivesModule } from 'src/app/directives/resource-directives.module';

const routes: Routes = [
  {
    path: '',
    component: SceneSettingsModalPage
  }
];

@NgModule({
  imports: [
    ResourceDirectivesModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ColorPickerModule,
    InformationPopupComponentModule,
    NgxPaginationModule,
    PipesModule,
  ],
  declarations: [
    SceneSettingsModalPage
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SceneSettingsModalPageModule {}
